import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import WrappedTextField from 'common/components/custom/WrappedTextField';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { createDepreciationGroup, updateDepreciationGroup } from '../api/apiDepreciationGroup';
import WrappedFromControlLabel from 'common/components/custom/WrappedFromControlLabel';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class CreateOrUpdateDepreciationGroup extends Component {

    emptyDepreciationGroup = {
        name: '',
        description: '',
        accountGroup: '',
        acceleratedRate: 0,
        regularRate: 0,
        lifeSpanInYears: 0,
        isActive: false
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            initialDepreciactionGroup: JSON.parse(JSON.stringify(this.emptyDepreciationGroup)),
            depreciationGroup: JSON.parse(JSON.stringify(this.emptyDepreciationGroup)),
            modelToDelete: JSON.parse(JSON.stringify(this.emptyDepreciationGroup))
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.depreciationGroupToEdit != null) {
            if (prevState.depreciationGroup.name !== this.props.depreciationGroupToEdit.name) {
                this.setState({ depreciationGroup: this.props.depreciationGroupToEdit, initialDepreciactionGroup: JSON.parse(JSON.stringify(this.props.depreciationGroupToEdit)) });
            }
        }
    }

    closeDialog = () => {
        this.props.onClose();
        this.setState({
            depreciationGroup: JSON.parse(JSON.stringify(this.emptyDepreciationGroup))
        });
    }

    handleChange = (event) => {
        const target = event.target;
        const name = target.name;
        let value = null;
        let { depreciationGroup } = this.state;
        value = target.type === 'number' ? value = Number(target.value) : target.type === 'checkbox' ? value = target.checked : value = target.value;
        depreciationGroup[name] = value;
        this.setState({ depreciationGroup: depreciationGroup })
    };


    createOrUpdateDepreciationGroup = (e) => {
        e.preventDefault();

        if (!this.validateForm()) {
            return;
        }

        const requestBodyCreate = {
            ...this.state.depreciationGroup,
            clientId: this.props.selectedClient.id
        }

        let action = this.props.depreciationGroupToEdit ? updateDepreciationGroup : createDepreciationGroup;
        action(this.props.depreciationGroupToEdit ? this.state.depreciationGroup : requestBodyCreate).then(response => {
            this.props.enqueueSnackbar(this.props.t(this.props.depreciationGroupToEdit ? 'update_message' : 'create_message', { title: this.props.t('depreciation_group') }), { variant: 'success' });
            this.closeDialog()
            this.props.getDepreciationGroups()
        }).catch(error => {
            if (error.response.status === 400) {
                this.props.enqueueSnackbar(this.props.t("depreciation_group_already_exists"), { variant: 'warning' });
            } else {
                this.props.enqueueSnackbar(this.props.t(this.props.depreciationGroupToEdit ? 'error_update_message' : 'error_create_message', { title: this.props.t('depreciation_group') }), { variant: 'error' });
            }
        });
    };

    validateForm() {
        let { depreciationGroup } = this.state;
        let valid = true;
        if (!depreciationGroup.name
            || !depreciationGroup.accountGroup
            || !depreciationGroup.regularRate
            || !depreciationGroup.acceleratedRate
        ) {
            valid = false;
        }
        return valid;
    }

    render() {
        let { depreciationGroup, initialDepreciactionGroup } = this.state

        return (
            <Dialog onClose={this.closeDialog} open={this.props.isOpen} TransitionComponent={Transition}>
                <DialogTitle className="dialog-header-custom">{this.props.depreciationGroupToEdit ? this.props.t("edit_depreciation_group") : this.props.t("new_depreciation_group")}</DialogTitle>
                <form onSubmit={this.createOrUpdateDepreciationGroup} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <WrappedTextField
                                            autoFocus
                                            label={"account_group"}
                                            name="accountGroup"
                                            onChange={this.handleChange}
                                            value={depreciationGroup.accountGroup}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"name"}
                                            name="name"
                                            onChange={this.handleChange}
                                            value={depreciationGroup.name}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"description"}
                                            name="description"
                                            onChange={this.handleChange}
                                            value={depreciationGroup.description}
                                            multiline
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"regular_rate"}
                                                type="number"
                                                name="regularRate"
                                                onChange={this.handleChange}
                                                value={depreciationGroup.regularRate}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"accelerated_rate"}
                                                type="number"
                                                name="acceleratedRate"
                                                onChange={this.handleChange}
                                                value={depreciationGroup.acceleratedRate}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"life_span_in_years"}
                                                type="number"
                                                name="lifeSpanInYears"
                                                onChange={this.handleChange}
                                                value={depreciationGroup.lifeSpanInYears}
                                            />
                                        </Grid>
                                    </Grid>
                                    {this.props.depreciationGroupToEdit !== null && <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <WrappedFromControlLabel
                                            onChange={this.handleChange}
                                            name="isActive"
                                            checked={depreciationGroup.isActive}
                                            label={"active"}
                                        />
                                    </Grid>}
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.closeDialog} variant="contained">
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained" disabled={this.props.depreciationGroupToEdit ? (JSON.stringify(depreciationGroup) === JSON.stringify(initialDepreciactionGroup)) : !this.validateForm()}>
                            {this.props.depreciationGroupToEdit ? this.props.t("update") : this.props.t("create")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog >
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(CreateOrUpdateDepreciationGroup)));
